import { HomeSectionEmptyStateProps } from './home-section-empty-state-props.interface';
import { Gamepad2, Search } from 'lucide-react';
import React from 'react';

const HomeSectionEmptyState: React.FC<HomeSectionEmptyStateProps> = ({ title, subtitle }) => (
  <div className="flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-slate-50 p-4 md:p-6">
    <div className="relative flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-blue-100 to-pink-100 text-[#3f54a4]">
      <Gamepad2 className="h-8 w-8" />
      <Search className="absolute -right-1 -bottom-1 h-6 w-6 rounded-full bg-white p-1 shadow" />
    </div>
    <div className="min-w-0 text-left">
      <h5 className="font-zillaSlab text-lg font-semibold text-slate-900">{title}</h5>
      <p className="mt-1 font-manrope text-sm text-slate-600">{subtitle}</p>
    </div>
  </div>
);

export default HomeSectionEmptyState;
